import Header from "components/Header/Header";
import React from "react";

function PrivacyPolicy() {
  return (
    <>
      <Header />
      <div className="homeSection">
        <div className="homeSection-content">
          <div className="wrapper-login-tos">
            <div className="container">
              <h3 className="navv-tos">Privacy Policy</h3>
            </div>
            <p>1. Introduction</p>
            <p>
              International American Massage & Body Professional ("we," "our," or "us") is committed to protecting
              your privacy and securing your personal information. This Privacy
              Policy explains how we collect, use, disclose, and safeguard your
              information when you use our escrow services, website, mobile
              applications, and related services (collectively, the "Services").
            </p>
            <p>2. Information We Collect</p>
            <p>
              <strong>2.1 Personal Identification Information</strong> <br />
              - Full name <br />
              - Date of birth <br />
              - Government-issued identification numbers <br />
              - Residential address <br />
              - Email address <br />
              - Phone number <br />
              - Photographs of identification documents <br />
              - Tax identification numbers <br />- Business registration
              information (if applicable)
            </p>
            <p>
              <strong>2.2 Financial Information</strong> <br />
              - Bank account details <br />
              - Credit/debit card information <br />
              - Transaction history <br />
              - Account balances <br />
              - Payment records <br />
              - Wire transfer information <br />- Digital wallet information
            </p>
            <p>
              <strong>2.3 Transaction Information</strong> <br />
              - Transaction parties' details <br />
              - Transaction amounts <br />
              - Description of goods/services <br />
              - Transaction dates <br />
              - Shipping information <br />- Communication records between
              parties
            </p>
            <p>
              <strong>2.4 Technical Information</strong> <br />
              - IP addresses <br />
              - Device information <br />
              - Browser type <br />
              - Operating system <br />
              - Access times <br />
              - Pages visited <br />
              - Click patterns <br />- Session duration
            </p>
            <p>3. How We Collect Information</p>
            <p>
              <strong>3.1 Direct Collection</strong> <br />
              - Account registration <br />
              - Transaction submissions <br />
              - Customer support interactions <br />
              - Document uploads <br />
              - Correspondence <br />- Survey responses
            </p>
            <p>
              <strong>3.2 Automatic Collection</strong> <br />
              - Cookies <br />
              - Web beacons <br />
              - Log files <br />
              - Analytics tools <br />- Mobile device identifiers
            </p>
            <p>
              <strong>3.3 Third-Party Sources</strong> <br />
              - Identity verification services <br />
              - Credit reporting agencies <br />
              - Public databases <br />
              - Business partners <br />- Banking partners
            </p>
            <p>4. How We Use Your Information</p>
            <p>
              <strong>4.1 Core Service Operations</strong> <br />
              - Process transactions <br />
              - Verify identities <br />
              - Facilitate escrow services <br />
              - Manage user accounts <br />
              - Process payments <br />- Provide customer support
            </p>
            <p>
              <strong>4.2 Security and Fraud Prevention</strong> <br />
              - Verify user identity <br />
              - Prevent fraudulent transactions <br />
              - Monitor suspicious activity <br />
              - Ensure platform security <br />- Comply with legal obligations
            </p>
            <p>
              <strong>4.3 Service Improvement</strong> <br />
              - Analyze usage patterns <br />
              - Improve user experience <br />
              - Develop new features <br />
              - Debug technical issues <br />- Conduct research and analysis
            </p>
            <p>
              <strong>4.4 Communication</strong> <br />
              - Service updates <br />
              - Transaction notifications <br />
              - Account alerts <br />
              - Marketing communications (with consent) <br />- Support
              responses
            </p>
            <p>5. Information Sharing and Disclosure</p>
            <p>
              <strong>5.1 Essential Business Partners</strong> <br />
              - Payment processors <br />
              - Banking partners <br />
              - Identity verification services <br />
              - Cloud service providers <br />- Security services
            </p>
            <p>
              <strong>5.2 Legal Requirements</strong> <br />
              - Court orders <br />
              - Subpoenas <br />
              - Regulatory requirements <br />
              - Law enforcement requests <br />- Government agencies
            </p>
            <p>5.3 Transaction Participants</p>
            <p>
              - Buyer and seller information as necessary <br />
              - Shipping details <br />
              - Transaction status updates <br />- Dispute resolution
              information
            </p>

            <p>6. Data Security</p>
            <p>
              <strong>6.1 Security Measures</strong> <br />
              - Encryption in transit and at rest <br />
              - Secure server infrastructure <br />
              - Access controls <br />
              - Regular security audits <br />
              - Employee training <br />- Incident response procedures
            </p>
            <p>
              <strong>6.2 Data Retention</strong> <br />
              - Transaction records: 7 years minimum <br />
              - Account information: Duration of account plus required retention
              period <br />
              - Communication records: 5 years <br />- Technical logs: 2 years
            </p>

            <p>7. Your Privacy Rights</p>
            <p>
              <strong>7.1 Access Rights</strong> <br />
              - Review personal information <br />
              - Download account data <br />
              - Request data formats <br />- Verify information accuracy
            </p>
            <p>
              <strong>7.2 Control Rights</strong> <br />
              - Update personal information <br />
              - Manage communication preferences <br />
              - Opt-out of marketing <br />- Delete account (subject to legal
              requirements)
            </p>
            <p>
              <strong>7.3 California Privacy Rights (CCPA)</strong> <br />
              - Right to know <br />
              - Right to delete <br />
              - Right to opt-out <br />- Right to non-discrimination
            </p>
            <p>
              <strong>7.4 European Privacy Rights (GDPR)</strong> <br />
              - Right to access <br />
              - Right to rectification <br />
              - Right to erasure <br />
              - Right to data portability <br />
              - Right to object <br />- Right to restrict processing
            </p>

            <p>8. International Data Transfers</p>
            <p>
              - Cross-border data transfer protocols <br />
              - Data protection agreements <br />
              - EU-US Privacy Shield compliance <br />
              - Standard contractual clauses <br />- Regional data storage
              options
            </p>

            <p>9. Children's Privacy</p>
            <p>
              We do not knowingly collect or maintain information from persons
              under 18 years of age without parental consent.
            </p>

            <p>10. Cookie Policy</p>
            <p>
              <strong>10.1 Types of Cookies</strong> <br />
              - Essential cookies <br />
              - Functional cookies <br />
              - Analytics cookies <br />- Marketing cookies
            </p>
            <p>
              <strong>10.2 Cookie Management</strong> <br />
              - Browser settings. <br />
              - Cookie preferences. <br />
              - Opt-out options. <br />- Third-party cookie controls.
            </p>

            <p>
              <strong>11. Changes to Privacy Policy</strong> <br />
              - Notice of material changes. <br />
              - Update notification methods. <br />
              - Effective date updates. <br />
              - Prior version archive. <br />- Consent requirements.
            </p>

            <p>
              <strong>12. Contact Information</strong> <br />
              - For privacy-related inquiries: <br />- Privacy Officer:{" "}
              <a href="mailto:privacy@iambp.com">
                privacy@iambp.com
              </a>{" "}
              <br />- Data Protection Officer:{" "}
              <a href="mailto:dpo@iambp.com">dpo@iambp.com</a>{" "}
              <br />
              - Postal Address: [Company Address] <br />- Phone: [Phone Number]
            </p>

            <p>
              <strong>13. Jurisdiction-Specific Provisions</strong>
            </p>
            <p>
              <strong>13.1 European Union</strong> <br />
              - GDPR compliance details. <br />
              - Data protection officer contact. <br />
              - Legal basis for processing. <br />- Cross-border transfer
              mechanisms.
            </p>
            <p>
              <strong>13.2 California</strong> <br />
              - CCPA compliance details. <br />
              - Shine the Light law compliance. <br />
              - Do Not Sell My Personal Information. <br />- Verified request
              process.
            </p>
            <p>
              <strong>13.3 Other Jurisdictions</strong> <br />
              - Regional compliance measures. <br />
              - Local data protection laws. <br />
              - Specific privacy requirements. <br />- Regional contact
              information.
            </p>

            <p>
              <strong>14. Dispute Resolution</strong> <br />
              - Internal complaint process. <br />
              - Regulatory authorities. <br />
              - Alternative dispute resolution. <br />
              - Jurisdiction and venue. <br />- Applicable law.
            </p>
            <p>
              By using our Services, you acknowledge that you have read and
              understood this Privacy Policy.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
